export enum factoryAreaEnum {
  怀集外发 = 2,
  广州外发 = 1,
  FOB = 3,
  江西外发 = 4,
}
